module.exports = __webpack_public_path__ + "img/daruntereinfuegen.98bd1dd.svg";